/// This is used for situation where the options of a select is based on another input

/// <script>window["o1"]={{"key": ["option1", "option2"]}}</script>
/// <select data-gs-toggle="select-dynamic-options" data-gs-target="#target" data-gs-name="o1"></select>

import { trigger } from './utility';

export default function (targetElem: HTMLElement) {
    let selectName = targetElem.dataset["gsTarget"];
    let selectElems = document.getElementsByName(selectName);
    if (selectElems.length == 0) {
        throw new Error(`Can not find target element: ${selectName}`);
    } else if (selectElems.length > 1) {
        throw new Error(`more than one select element find: ${selectName}`);
    }
    let selectElem = selectElems[0] as HTMLSelectElement;
    if (selectElem.nodeName !== "SELECT") {
        throw new Error(`the target element (${selectName}) has to be a select element`);
    }
    let globalVauleName = targetElem.dataset['gsName'];

    if (globalVauleName === undefined) {
        throw new Error('Please provide the data-gs-name attribute');
    } else if (!(globalVauleName in window)) {
        throw new Error(`Can not find the name '${globalVauleName}' in window`);
    }
    let options = window[globalVauleName];
    selectElem.addEventListener("change", function (e) {
        if ((<any>e).detail && (<any>e).detail.init) {
            e.preventDefault();
            return;
        }
        var value = selectElem.value;
        var option = options[value] as string[];

        while (targetElem.hasChildNodes()) {
            targetElem.removeChild(targetElem.lastChild);
        }

        if (option === undefined) {
            return;
        }

        for (var i = 0; i < option.length; i++) {
            var optionValue = option[i];
            var opt = document.createElement('option');
            opt.value = optionValue;
            opt.innerHTML = optionValue;
            targetElem.appendChild(opt);
        }
        (targetElem as HTMLSelectElement).selectedIndex = 0;
        trigger(targetElem, 'change');
    });
}